module.exports = __webpack_public_path__ + "static/media/mayzorlogin.13fe90b2.png";